<div class="my-modal">
    <div>
        <h4 class="titleModal">{{message}}</h4>
    </div>
    <div class="btnModal">
        <button class="mini-button single" (click)="close()">OK</button>
    </div>
</div>